import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

const Getusers = (props) => {
  const { accounts } = useMsal();
  const [userInfo, setUserInfo] = useState({ name: "", email: "" });

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      const account = accounts[0];
      setUserInfo({
        name: account.name || "",
        email: account.username || "", // Usually the user's email
      });
      localStorage.setItem("email",account.username)
      localStorage.setItem("name",account.name)

    }
  }, [accounts]);

  const getNameAbbreviation = (fullName) => {
    if (fullName) {
      const nameParts = fullName.trim().split(" ").filter(Boolean);
      if (nameParts.length >= 2) {
        return `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase();
      }
    }
    return "";
  };

  const getFirstName = (fullName) => {
    if (fullName) {
      const nameParts = fullName.trim().split(" ").filter(Boolean);
      return nameParts[0] || "";
    }
    return "";
  };

  return (
    <>
      {props?.name && (
        <span className={`colorCss ${props.className}`} style={{ display: "grid", gridGap: "5px", justifyContent: "center",fontSize:"20px" }}>
          {userInfo.name}
        </span>
      )}
      {props?.email && (
        <span className={`colorCss ${props.className}`} style={{ display: "grid", gridGap: "5px", justifyContent: "center",fontSize:"14px" }}>
          {userInfo.email}
        </span>
      )}
      {props?.trim && (
        <span className={`userinfo colorCss ${props.className}`} style={{ display: "grid", gridGap: "5px", justifyContent: "center" }}>
          {getNameAbbreviation(userInfo.name)}
        </span>
      )}
      {props?.firstName && (
        <span className={`userinfo colorCss ${props.className}`} style={{ display: "grid", gridGap: "5px", justifyContent: "center" }}>
          {getFirstName(userInfo.name)}
        </span>
      )}
    </>
  );
};

export default Getusers;
